<template>
    <v-autocomplete
            v-model="selected"
            :items="itemsToShow"
            chips
            :label="labelToShow"
            :item-text="titleToShow"
            :return-object=true
            :multiple="isMultiple"
            outlined
            :disabled = "lock"
            :error-messages="errorMsg"
            :error-count="errorCnt"
    >
        <template
                slot="selection"
                slot-scope="data"
        >
            <v-chip
                    :input-value="data.selected"
                    close
                    class="chip--select-multi"
                    @click:close="removeItem(data.index)"
            >
                {{ data.item[title] }}
            </v-chip>
        </template>
        <template
                slot="item"
                slot-scope="data"
        >
            <template>
                <v-list-item-content>
                    <v-list-item-title v-html="data.item[titleToShow]"></v-list-item-title>
                    <v-list-item-subtitle v-html="createSubTitle(data.item)"></v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </template>
    </v-autocomplete>
</template>

<script>
    export default {
        name: "Autocomplete",
        props:['items', 'label', 'title', 'subTitle', 'selectedItems', 'multipleItems',
        'errorMessages', 'errorCount', 'setFieldLock'],
        data(){
            return {
                selected: this.selectedItems,
                errorMsg: [],
                lock: this.setFieldLock || false,
            }
        },
        computed:{
            itemsToShow(){
                return this.items;
            },
            labelToShow(){
                return this.label;
            },
            titleToShow(a,b){
                return this.title;
            },
            isMultiple(){
                return this.multipleItems === undefined ? true: this.multipleItems;
            },
            errorCnt(){
                return this.errorCount;
            }
        },
        watch:{
            selected(newValue){
                this.$emit('autocomplete-selected',newValue);
            },
            selectedItems(newValue){
                this.selected = newValue;
            },
            errorMessages(value){
                this.errorMsg =  value;
            },
            setFieldLock(value){
                this.lock = value;
            },
        },
        methods:{
            removeItem(index){
                if(this.selected.length > 0) {
                    this.selected.splice(index, 1);
                }
                else{
                    this.selected = [];
                }
            },
            createSubTitle(item){
                let finalSubTitle = [];
                if(this.subTitle === null){
                    return ;
                }
                for(let prop = 0; prop < this.subTitle.length; prop++){
                    if(item.hasOwnProperty(this.subTitle[prop])){
                        finalSubTitle.push(item[this.subTitle[prop]])
                    }else{
                        finalSubTitle.push(this.subTitle[prop])
                    }
                }

                return finalSubTitle.join(' | ');
            },
        }
    }
</script>

<style scoped>

</style>